module.exports = __webpack_public_path__ + "static/media/Chuck Bachorski Headshot.88d85e52.jpeg";